<div class="postal-wrapper">
  <input
    #postalInput
    id="postalInput"
    name="postalInput"
    type="text"
    class="postal-input"
    [disabled]="disabled"
    [placeholder]="'partners.input-zip-code' | translate"
  />
</div>
